import { motion } from "framer-motion";

// Vertical dashed pathway with animated nodes representing warm handoffs.
export default function Pathway({ nodes = 4, className = "" }) {
  const positions = Array.from({ length: nodes }, (_, i) => (i / (nodes - 1)) * 100);
  return (
    <div className={`absolute inset-y-0 left-1/2 -translate-x-1/2 w-px pointer-events-none ${className}`} aria-hidden>
      <svg width="2" height="100%" viewBox="0 0 2 100" preserveAspectRatio="none" className="absolute inset-0 w-full h-full">
        <motion.line
          x1="1" y1="0" x2="1" y2="100"
          stroke="#0B1B3D"
          strokeOpacity="0.25"
          strokeWidth="1"
          strokeDasharray="3 5"
          initial={{ pathLength: 0 }}
          whileInView={{ pathLength: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 2, ease: "easeOut" }}
        />
      </svg>
      {positions.map((p, i) => (
        <motion.div
          key={i}
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ delay: i * 0.15, duration: 0.4 }}
          style={{ top: `${p}%` }}
          className="absolute -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-gold ring-4 ring-white shadow-sm"
        />
      ))}
    </div>
  );
}
